$(document).ready(function () {
  // PLP click sur les images produits
  // Redirection au clic sur l'image des cards
/*   $(document).on('click', '.card__media, .swiper-wrapper', function () {
    var redirect = $(this).data("target");
    if (redirect) {
      window.location.href = redirect;
    }
  }); */

  // Ouverture disponibilité
  $(document).on('click', '#drawer_disponibilite.drawer .drawer_close', function () {
    $("body").removeClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").removeClass("active");
  });

  $(document).on('click', '.shop_availability', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").addClass("active");
  });

  $(document).on('click', '.boutique_heading', function () {
    $(this).next('.boutique_details').toggleClass("show_details");
  });

  showProductSizes();

  // Position de l'aside facets au scroll
  $(document).scroll(function () {
    var header_height = $(".header").height();
    if ($(".shopify-section-header-hidden").length > 0) {
      $(".facets-wrapper").css("top", "0px");
    } else {
      $(".facets-wrapper").css("top", header_height + "px");
    }
  });


  $(document).on('click', '.mobile-facets__label', function () {
    // attends 500ms pour que le DOM soit bien chargé
    setTimeout(function () {
      initSwipers();
      showProductSizes();
    }, 800);
  });

  // Data target cliquables
  $('[data-target_section]').click(function () {
    document.location.href = $(this).data("target_section");
  });

  // on click on data-klaviyo_target buttons
  $(document).on("click", '[data-klaviyo_target]', function () {
    var klaviyo_target = $(this).data('klaviyo_target');

    if (typeof klaviyo_target === 'undefined') {
      return;
    }

    $('html, body').animate({
      scrollTop: $("." + klaviyo_target).offset().top
    }, 500);
  });

  $(document).scroll(function () {

    // Au scroll
    const preorder_button = $('#shopify-block-klaviyo_email_marketing_sms_form_embed_block_Gqea6Y');
    const sticky_basket = $('.sticky_preorder');

    if (preorder_button.length === 0) {
      return;
    }

    const isVisible = isInViewport(preorder_button);

    if (isVisible) {
      sticky_basket.slideUp(200);
    }
    else {
      sticky_basket.slideDown(200);
    }
  });


  // Sticky button sur fiche produit
  $(".sticky_button").click(function () {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".product__info-wrapper").offset().top
    }, 400);
  })

  // Au scroll
  const add_to_cart_buttons = $('.product-form__buttons');
  const sticky_basket = $('#sticky_basket');

  $(document).scroll(function () {
    const isVisible = isInViewport(add_to_cart_buttons);

    if (isVisible) {
      //sticky_basket.css('display', 'none');
      sticky_basket.slideUp(200);
    }
    else {
      //sticky_basket.css('display', 'flex');
      //sticky_basket.show();

      //sticky_basket slide up
      sticky_basket.slideDown(200);

    }
  });

  initSwipers();

  $("#sticky_basket .bis_trigger").click(function () {
    $(".klaviyo-bis-trigger").click();
  })

  // accordeon
   // Comportement questions FAQ, CGV, Mentions
   $(".accordeon").on("click", "h3", function () {
    var $currentQ = $(this);
    var $currentA = $currentQ.next("div");

    // Ferme toutes les autres réponses + retire leurs classes
    $(".accordeon h3").not($currentQ).removeClass("opened");
    $(".accordeon h3").not($currentQ).next("div").stop(true, true).slideUp();

    // Toggle sur l'élément cliqué
    if ($currentQ.hasClass("opened")) {
      $currentQ.removeClass("opened");
      $currentA.stop(true, true).slideUp();
    } else {
      $currentQ.addClass("opened");
      $currentA.stop(true, true).slideDown();
    }
  });


});


// Réinitialise les functions appliquées à la card product après un changement dans le DOM
var observeDOM = (function () {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      // define a new observer
      var mutationObserver = new MutationObserver(callback);

      // have the observer observe for changes in children
      mutationObserver.observe(obj, { childList: true, subtree: false });
      return mutationObserver;
    }

    // browser support fallback
    else if (window.addEventListener) {
      obj.addEventListener("DOMNodeInserted", callback, false);
      obj.addEventListener("DOMNodeRemoved", callback, false);
    }
  };
})();

// Réinitialise les functions appliquées à la card product après un changement dans le DOM
observeDOM(document.getElementById("ProductGridContainer"), function (m) {
  console.log("DOM has changed");
  initSwipers();
  showProductSizes();
});

// Survol d'une carte produit : affiche les variantes de tailles a la place des
// declinaisons de couleurs. Fonction globale pour pouvoir etre rappelee apres
// une injection dynamique de cartes (ex : section "Vus recemment").
function showProductSizes() {
  $(".grid__item .card__inner").hover(function (e) {
    if ($(this).next(".card__content").find(".product_variants").length) {
      $(this).next(".card__content").find(".declinaisons_plp").css("opacity", "0");
      $(this).next(".card__content").find(".product_variants:not(.no_associated_products)").css("opacity", "1");
    }
  }, function (e) {
    $(this).next(".card__content").find(".declinaisons_plp").css("opacity", "1");
    $(this).next(".card__content").find(".product_variants:not(.no_associated_products)").css("opacity", "0");
  });
}

function initSwipers() {
  // Securite : si la librairie Swiper n'est pas encore chargee, on reessaie
  // une fois qu'elle est disponible (evite un crash silencieux du script).
  if (typeof Swiper === "undefined") {
    window.addEventListener("load", initSwipers, { once: true });
    return;
  }

  var isMobile = window.matchMedia("(max-width: 749px)").matches;
  var $target = $(".mySwiper");
  if ($target.length) {
    // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
    $target.each(function () {
      var $swiper = $(this);

      // Déjà initialisé : on ne réinitialise pas (évite les doublons).
      if ($swiper.hasClass("swiper-initialized")) {
        return;
      }

      // Sur mobile, on désactive le carrousel des cartes situées dans un
      // slider-component : le slider parent gère le défilement horizontal,
      // le swiper de la carte entrerait en conflit avec lui.
      if (isMobile && $swiper.closest("slider-component").length) {
        $swiper.addClass("swiper-disabled-mobile");
        return;
      }

      new Swiper($swiper.get(0), {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
        },
        breakpoints:{
          0: {
            allowTouchMove: true,
          },
          789: {
            allowTouchMove: true,
          },
        }
      });
    });
  }
}

function initSwipersLazy() {
  var $target = $(".mySwiper").not(".swiper-initialized");
  if ($target.length) {
    // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
    $target.each(function () {
      var $that = $(this);
      $(this).find("img").first().on("load", function () {
        new Swiper($that.get(0), {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
          }
        });
      });
    });
  }
}

// Test viewport
function isInViewport(el) {
  if (typeof el.get(0) === 'undefined') {
    return false;
  }

  const rect = el.get(0).getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= ($(window).height() || $(document).height()) &&
    rect.right <= ($(window).width() || $(document).width())
  );
}

